import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { environment } from 'environments/environment';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class MessageNotificationService {
    protected apiRoute = environment.RESOURCE_API;

    constructor(private _httpClient: HttpClient) { }

    getByCompanyId(companyId: string, userId: string, category: string = 'Tout',pageNumber: number = 1, pageSize: number = 4): Observable<any> {
        const route = this.apiRoute +
            environment.apiCatalog.messageNotification.controllerRoute +
            environment.apiCatalog.messageNotification.subRoutes.getByCompanyId +
            companyId;

        let params = new HttpParams()
            .set('userId', userId)
            .set('category', category)
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString());

        return this._httpClient.get(route, { params });
    }

    getByCompanyIds(companyIds: string[], userId: string, category: string = 'Tout', pageNumber: number = 1, pageSize: number = 4): Observable<any> {
        const route = this.apiRoute + environment.apiCatalog.messageNotification.controllerRoute + environment.apiCatalog.messageNotification.subRoutes.getByCompanyIds;

        let params = new HttpParams()
            .set('userId', userId)
            .set('category', category)
            .set('pageNumber', pageNumber.toString())
            .set('pageSize', pageSize.toString());

        return this._httpClient.post(route, companyIds, { params });
    }

    markAllAsRead(companyId: string, userId: string): Observable<any> {
        const route = this.apiRoute +
            environment.apiCatalog.messageNotification.controllerRoute +
            environment.apiCatalog.messageNotification.subRoutes.markAllAsRead +
            companyId;

        let params = new HttpParams().set('userId', userId);
        return this._httpClient.put(route, {}, { params });
    }

    markAllAsReadByCompanyIds(companyIds: string[], userId: string): Observable<any> {
        const route = this.apiRoute +
            environment.apiCatalog.messageNotification.controllerRoute +
            environment.apiCatalog.messageNotification.subRoutes.markAllAsReadByCompanyIds;
        let params = new HttpParams().set('userId', userId);
        return this._httpClient.post(route, companyIds, { params });
    }

    toggleSingleRead(notificationId: string, companyId: string, userId: string): Observable<any> {
        const route = this.apiRoute +
            environment.apiCatalog.messageNotification.controllerRoute +
            environment.apiCatalog.messageNotification.subRoutes.toggleSingleRead +
            notificationId;

        let params = new HttpParams()
            .set('companyId', companyId)
            .set('userId', userId);

        return this._httpClient.put(route, {}, { params });
    }
}